import { UsersComponent } from './users/users.component';
 
export const allContainerComponents = [UsersComponent];